import React from "react";
import type { ItemInterface } from "./types";
import DispensationTable from "./DispensationTable";

type Props = {
  onClickItem: (item: ItemInterface) => void;
}

const DispensationTableContainer: React.FC<Props> = ({ onClickItem }) => {

  return <DispensationTable onClick={onClickItem} />;
};

export default DispensationTableContainer;